<template>
  <div class="left">
    <div class="price-top">
      <Price />
    </div>
    <Bottom />
  </div>
</template>
<script>
import Bottom from "./Bottom/index";
import Price from "./Price/index"
export default {
  components: {
    Bottom,
    Price,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.left {
  width: 514px;
  height: 100%;
  position: absolute;
  top: -38px;
  .price-top {
    width: 100%;
    height: 447px;
    background: url("../../assets/bgIcon/price.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>